/* eslint-disable @typescript-eslint/no-empty-interface */
import { Injectable } from '@angular/core';

import { UserDto } from '@bms-client/api';
import { createAction, createReducer, on, props } from '@ngrx/store';

export interface ICurrentUserState extends UserDto {
    authToken?: string;
}

export const DEFAULT_STATE_CURRENT_USER: ICurrentUserState = {};

// Actions
export const CURRENT_USER_CLEAR_ACTION_NAME = '[Current User] Clear';
export const CURRENT_USER_UPDATE_PROFILE_DATA_ACTION_NAME = '[Current User] Update profile data';

export const clearCurrentUser = createAction(CURRENT_USER_CLEAR_ACTION_NAME);
export const updateCurrentUserProfileData = createAction(CURRENT_USER_UPDATE_PROFILE_DATA_ACTION_NAME, props<ICurrentUserState>());

// Reducers
export const currentUserReducer = createReducer<ICurrentUserState>(
    DEFAULT_STATE_CURRENT_USER,
    on(clearCurrentUser, () => DEFAULT_STATE_CURRENT_USER),
    on(updateCurrentUserProfileData, (state, profileData) => ({ ...state, ...profileData })),
);

@Injectable()
export class DummyEffects {}
